class InfoSlider {
    constructor(target) {
        this.state = {
            target,
            slideshow: null,
            timer: null,
            current: 0,
            nextSlide: 1,
            slideCount: Array.from(target.getElementsByClassName('infoslider__slide')).length,
            slidesArr: [],
            interval: 7500,
            pauseOnHover: true,
            slider: target,
            arrow: Array.from(target.getElementsByClassName('infoslider__arrow')),
            control: Array.from(target.getElementsByClassName('infoslider__control')),
            hideSlide: 'infoslider__slide--hidden',
            controlOff: 'infoslider__control--deselect',
        };

        this._setSlides = () => {
            for (let i = 0; i < this.state.slideCount; i++) {
                this.state.slidesArr.push(`div[data-slide="${i}"]`);
            }
        };

        this._slide = () => {
            this.state.slideshow = setInterval(() => {
                this.transition(
                    '.infoslider__slide',
                    this.state.slidesArr[this.state.nextSlide],
                    this.state.hideSlide,
                );
                this.transition(
                    '.infoslider__control',
                    `a[data-control="${this.state.nextSlide}"]`,
                    this.state.controlOff,
                );
                this.state.current = this.state.nextSlide;
                this.state.nextSlide =
                    this.state.nextSlide + 1 >= this.state.slidesArr.length
                        ? 0
                        : this.state.nextSlide + 1;
            }, this.state.interval + 1200);
        };

        this.transition = (elOne, elTwo, change) => {
            Array.from(this.state.slider.querySelectorAll(elOne)).forEach((k) =>
                k.classList.add(change),
            );
            Array.from(this.state.slider.getElementsByClassName('js--infoslider-bg')).forEach((k) =>
                k.classList.remove('infoslider__bg--active'),
            );

            setTimeout(() => {
                this.state.slider
                    .querySelector(`.js--infoslider-bg[data-bg="${this.state.current}"]`)
                    .classList.add('infoslider__bg--active');
            }, 100);

            setTimeout(() => {
                this.state.slider.querySelector(elTwo).classList.remove(change);
                this.state.arrow.forEach((k) => k.classList.remove('infoslider__arrow--disabled'));
            }, 200);
        };

        this.resizeSlide = () => {
            const slideHeights = [];
            for (let i = this.state.slidesArr.length - 1; i >= 0; i--) {
                slideHeights.push(
                    getComputedStyle(this.state.slider.querySelector(`${this.state.slidesArr[i]}`))
                        .height,
                );
            }

            const height = slideHeights.sort((a, b) => parseInt(a, 10) - parseInt(b, 10)).pop();
            this.state.target.getElementsByClassName('js--slides')[0].style.height = height;
        };

        this._slideArrows = (arrow) => {
            this.state.arrow.forEach((k) => k.classList.add('infoslider__arrow--disabled'));
            clearInterval(this.state.slideshow);

            if (arrow === 'right') {
                this.transition(
                    '.infoslider__slide',
                    `div[data-slide="${this.state.nextSlide}"]`,
                    this.state.hideSlide,
                );
                this.transition(
                    '.infoslider__control',
                    `a[data-control="${this.state.nextSlide}"]`,
                    this.state.controlOff,
                );
                this.state.current = this.state.nextSlide;
                this.state.nextSlide =
                    this.state.current + 1 >= this.state.slidesArr.length
                        ? 0
                        : this.state.current + 1;
                return;
            }

            this.state.nextSlide =
                this.state.nextSlide - 1 <= 0
                    ? this.state.slidesArr.length - 1
                    : this.state.nextSlide - 1;

            if (this.state.current === 0) {
                this.state.nextSlide = 0;
            }

            this.state.current =
                this.state.current === 0 ? this.state.slidesArr.length - 1 : this.state.current - 1;
            this.transition(
                '.infoslider__slide',
                `div[data-slide="${this.state.current}"]`,
                this.state.hideSlide,
            );
            this.transition(
                '.infoslider__control',
                `.infoslider__control[data-control="${this.state.current}"]`,
                this.state.controlOff,
            );
        };

        this.state.controls = (controlCount) => {
            clearInterval(this.state.slideshow);

            this.transition(
                '.infoslider__slide',
                `div[data-slide="${controlCount}"]`,
                this.state.hideSlide,
            );
            this.transition(
                '.infoslider__control',
                `a[data-control="${controlCount}"]`,
                this.state.controlOff,
            );
            this.state.current = parseInt(controlCount, 10);
            this.state.nextSlide =
                this.state.current + 1 >= this.state.slidesArr.length ? 0 : this.state.current + 1;
        };

        this._throttleOrDie = () => {
            clearTimeout(this.state.timer);
            this.state.timer = setTimeout(() => this.resizeSlide(), 250);
        };
    }

    init() {
        this._setSlides();
        this._slide();

        this.state.slider.addEventListener('mouseover', () => clearInterval(this.state.slideshow));
        this.state.slider.addEventListener('mouseout', () => this._slide());
        this.state.control.forEach((k) =>
            k.addEventListener('click', (e) =>
                e.target.classList.contains('infoslider__control--deselect')
                    ? this.state.controls(e.target.getAttribute('data-control'))
                    : false,
            ),
        );
        this.state.arrow.forEach((k) =>
            k.addEventListener('click', () => this._slideArrows(k.getAttribute('data-arrow'))),
        );
        window.addEventListener('resize', () => this._throttleOrDie());
        setTimeout(this.resizeSlide, 0);
    }
}

function init() {
    const arr = [];

    Array.from(document.getElementsByClassName('infoslider')).forEach((k) => {
        arr.push(() => new InfoSlider(k).init());
    });

    arr.forEach((k) => k());
}

export default init;
